import React, { useEffect, useState } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";
import { getBlog } from "api/blog";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;

export default function BlogPost ({ headingText = "Terms And Condition" }) {
  const [post, setPost] = useState(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search);
    if (searchParams.get('id')) {
      getBlog(searchParams.get('id')).then(response => {
        console.log("Blog post fetched:", response);
        setPost(response);
      }).catch(error => {
        console.error("Error fetching blog post:", error);
      });
    } else {
      window.location.href = "/info-corner";
    }
  }, [])

  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{post?.title}</Heading>
          </HeadingRow>
          <Text>

            <p>Last updated: {post?.updated_date ? post?.updated_date : post?.created_date}</p>

            {/* <p>Please read these terms and conditions carefully before using Our Service.</p>

            <h1>Interpretation and Definitions</h1>
            <h2>Interpretation</h2> */}
            <br/>
              <div dangerouslySetInnerHTML={{__html: post?.post}}></div>
            {/* </p> */}
          </Text>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
